import React, { FC } from 'react';
import { View } from 'react-native';
import styles from './styles';
import GenreButton from '../GenreButton';

export type FanGenreButtonListProps = {
  genres: any[];
  activeGenres: any[];
  limitReached?: boolean;
  minSelectedThreshold?: boolean;
  onPress?: (e: any) => void;
};

export const FanGenreButtonList: FC<FanGenreButtonListProps> = (props) => {
  const {
    genres,
    activeGenres,
    limitReached,
    minSelectedThreshold,
    onPress,
  } = props;
  return (
    <View style={styles.container}>
      {genres.length > 0 &&
        genres.map((genreObj) => {
          const isActive = activeGenres.find(
            (item) => item?.genre == genreObj.genre,
          );
          return (
            <GenreButton
              key={genreObj.id}
              isActive={isActive}
              genreObj={genreObj}
              minSelectedThreshold={minSelectedThreshold || false}
              limitReached={limitReached}
              onPress={onPress}
            />
          );
        })}
    </View>
  );
};

export default FanGenreButtonList;
